import React from "react";
import PropTypes from "prop-types";

const ChevronUp = ({ className, color }) => {
  return (
    <svg className={className} viewBox="0 0 12.42 6.57">
      <g>
        <polyline
          fill="none"
          stroke={color}
          strokeWidth={0.5}
          points="12.25 6.39 6.21 0.35 0.18 6.39"
        />
      </g>
    </svg>
  );
};

ChevronUp.defaultProps = {
  className: ``,
  color: `#231f20`
};

ChevronUp.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string
};

export default ChevronUp;
